/** @jsx isolateComponent */
import { css } from '@emotion/core';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Colors, Icon, Typography } from '@zapier/design-system';
import SkipButton from '@zapier/product-get-help/esm/components/shared/SkipButton';
import FolderGroup from '../FolderGroup';
const emptyCss = css `
  height: 330px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  align-content: stretch;
`;
const emptyTextCss = () => css `
  ${Typography.sectionHeader3}
  font-weight: 600;
  color: ${Colors.neutral800};
  margin-top: 20px;
`;
const rootCss = css `
  display: grid;
  grid-gap: 30px;
`;
/** Renders all groups of folders with Zaps for `<Open>`. */
const Browser = ({ data, isFiltered, kindDisplayName, onSelect, }) => {
    const hasData = data.length > 0;
    return (isolateComponent("div", { css: rootCss },
        isolateComponent(SkipButton, { onSelect: onSelect }, `I don’t need help with a specific ${kindDisplayName}`),
        hasData ? (isolateComponent("ol", null, data.map(group => (isolateComponent(FolderGroup, Object.assign({ forceFoldersOpen: isFiltered, key: group.title, onSelect: onSelect }, group)))))) : (isolateComponent("div", { css: emptyCss },
            isolateComponent(Icon, { color: 'neutral800', name: "navSearch", size: 64 }),
            isolateComponent("span", { css: emptyTextCss() }, "No Results")))));
};
export default Browser;
